export default {
  documents: [],
  summary: null,
  fullSummary: null,
  pagination: {
    currentPage: 1,
    totalPage: 1,
    pageTotal: 0,
    totalItem: 0,
  },
  hasDocuments: {
    ar: false,
    ap: false,
  },
}

